import { ApiHelper } from "api/ApiHelper";

// Toolkit selectObject hardcodes /data/DATANAC/…, so MCO (a different section) goes
// through callPost directly. See datanac_core_dbx payment_spec.md for object/payload shapes.
export function MCOService() {
  const post = (module, object, values) =>
    ApiHelper.callPost(
      `data/MarginCoverageOption/${module}/${object}/SelectObject`,
      Object.fromEntries(Object.entries(values || {}).filter(([, v]) => v != null && v !== ""))
    );

  const actions = {
    selectOfficial: (object, values) => post("Official", object, values),
    selectMirror: (object, values) => post("Mirror", object, values),
  };

  return { actions };
}
